import React, { useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector, ReactReduxContext } from 'react-redux'
import * as paymentStatementCopanActions from 'store/modules/paymentStatementCopan/actions'
import { DateTime } from 'luxon'
import get from 'lodash.get'
import { Alert, Container, Row, Col, Button, Spinner, Modal } from 'react-bootstrap'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import ptBR from 'date-fns/locale/pt-BR'
import { processDownload } from '../../../../helpers/download'
import MaskedInput from 'react-maskedinput'
import Typography from 'components/atoms/Typography'
import IconPDF from 'assets/img/icone-pdf.png'
import IconXLS from 'assets/img/icone-xls.png'
import IconXML from 'assets/img/icone-xml.png'
import IconXMLExchange from 'assets/img/icone-xml-exchange.png'
import TrashCanIcon from 'assets/img/icons8-trash-can-28.svg'
import 'react-datepicker/dist/react-datepicker.css'
import 'styles/datepicker.scss'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'styles/responsive-table.scss'
import './DemonstrativoPagamentoCopan.scss'
import CustomModal from 'components/molecules/CustomModal'
import { isDebugMode } from 'helpers/tools'

setDefaultLocale('pt-BR')
registerLocale('pt-BR', ptBR)

function checkExistingRequest(date) {
  const reportsBeingGeneratedCopan = JSON.parse(localStorage.getItem('reportsBeingGeneratedCopan'))
  let exists = reportsBeingGeneratedCopan
    ? reportsBeingGeneratedCopan.filter((item) => {
        return item.date === date && item.created_at == new Date().toISOString().split('T')[0]
      })
    : []
  return exists.length > 0
}

function DemonstrativoPagamentoCopan(props) {
  const { data, user } = props

  let login_user = useSelector((state) => state?.auth?.user)

  const dispatch = useDispatch()
  const { store } = useContext(ReactReduxContext)
  const reportsData = useSelector((state) => state.paymentStatementCopan.docs)
  const errorPaymentDemonstrativeCopan = useSelector(
    (state) => state.paymentStatementCopan.errorPaymentDemonstrativeCopan
  )
  const datesWithNoDataCopan = useSelector((state) => state.paymentStatementCopan.datesWithNoDataCopan)
  const breadcrumb = get(props, 'data.breadcrumb') || []

  const [reportsInProgress, setReportsInProgress] = useState([])
  const [intervalId, setIntervalId] = useState(null)
  const [startDate, setStartDate] = useState(new Date())
  const [show, setShow] = useState(true)
  const [generatingNewDoc, setGeneratingNewDoc] = useState(false)
  const [loadingFile, setLoadingFile] = useState('')
  const [debugMode, setDebugMode] = useState(false)

  const token = useSelector((state) => state?.token)

  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [customInput, setCustomInput] = useState('')

  const handleClose = () => {
    setShowError(false)
    setErrorMessage('')
  }
  const handleShow = () => setShowError(true)

  const generateDocs = (date) => {
    if (!date || typeof date !== 'object') {
      setErrorMessage('Data inválida.')
      handleShow()
      setStartDate(Date.now())
      return false
    }

    const dt = new Date(date).toISOString()

    setGeneratingNewDoc(true)

    const formattedDate = DateTime.fromISO(dt).toISODate()

    if (datesWithNoDataCopan.indexOf(formattedDate) >= 0) {
      setErrorMessage('Nenhum dado encontrado para a data especificada.')
      handleShow()
      setGeneratingNewDoc(false)
      return false
    }

    if (!checkExistingRequest(formattedDate)) {
      dispatch(
        paymentStatementCopanActions.generateDocsCopan({ date: formattedDate, uid: login_user?.contract, store, debugMode })
      )
    } else {
      setErrorMessage(
        <>
          <p>Já existe uma solicitação de Demonstrativo de Pagamento para esta data.</p>
          <br />
          <p>Você pode deletar um item para gerar novamente com a mesma data.</p>
        </>
      )
      handleShow()
      setGeneratingNewDoc(false)
    }
  }

  const removeDoc = (index) => {
    const reportsBeingGeneratedCopan = JSON.parse(localStorage.getItem('reportsBeingGeneratedCopan'))
    dispatch(paymentStatementCopanActions.removeDocCopan(index))
    reportsBeingGeneratedCopan.splice(index, 1)
    localStorage.setItem('reportsBeingGeneratedCopan', JSON.stringify(reportsBeingGeneratedCopan))
    setReportsInProgress(reportsBeingGeneratedCopan)
  }

  const renderAlert = () => {
    if (show) {
      return (
        <Alert
          variant="orange"
          className="mt-4 mb-4 payment-statement__alert"
          onClose={() => setShow(false)}
          dismissible
        >
          <div className="d-flex mb-1" style={{ alignItems: 'center' }}>
            <i className="icone-alert mr-2" />

            <Typography variant="p" color="dark-contrast-color">
              ATENÇÃO
            </Typography>
          </div>

          <Typography variant="p" color="dark-contrast-color">
            Para visualizar o Demonstrativo, é necessário ter em seu computador o software (Programa) Acrobat Reader 7.0
            ou versão superior.
          </Typography>

          <Typography variant="p" color="dark-contrast-color" cssClass="mb-3">
            Caso não possua, e queira instala-lo agora, clique aqui, para fazer o download gratuito.
          </Typography>

          <Typography variant="p" color="dark-contrast-color">
            <strong>Obs:</strong> Caso a geração do demonstrativo apresente alguem problema clique aqui para obter
            ajuda.
          </Typography>
        </Alert>
      )
    }
  }

  const renderTableItems = (items) => {
    return items.map((item, index) => {
      if (datesWithNoDataCopan.indexOf(item.date) >= 0) {
        return
      }

      const pdfReport = get(item, 'applications.paymentDemonstrative.reportsPerDay.pdf_report')
      const xlsReport = get(item, 'applications.paymentDemonstrative.reportsPerDay.xls_report')
      const xmlReport = get(item, 'applications.paymentDemonstrative.reportsPerDay.xml_report')
      const xmlReportExchange = get(item, 'applications.paymentDemonstrative.reportsPerDay.xml_report_exchange')
      const hasDocument = get(item, 'applications.paymentDemonstrative.reportsPerDay.success')
      const date = DateTime.fromISO(item.date).toFormat('dd/MM/yyyy')

      return (
        <Tr key={index}>
          <Td className="text-gray-100 payment-statement__report-status">
            {hasDocument ? (
              <div className="payment-statement__available"> Disponível </div>
            ) : (
              <div className="payment-statement__loading">
                <Spinner animation="border" role="status" size="sm">
                  <span className="sr-only">Processando...</span>
                </Spinner>
                Processando
              </div>
            )}
          </Td>
          <Td className="text-gray-100 payment-statement__report-date">{date}</Td>
          <Td className={'text-gray-100'}>
            <div className={'payment-statement__report'}>
              {(!loadingFile || loadingFile != pdfReport) && (
                <Button
                  className={`${pdfReport ? 'payment-statement__report--done' : ''}`}
                  title="Baixar relatório em PDF"
                  variant="link"
                  disabled={!pdfReport}
                  onClick={() => processDownload(token, `/api/v1/payment/file/${pdfReport}`, pdfReport, setLoadingFile)}
                >
                  <img src={IconPDF} alt="ícone de representação de um arquivo PDF" />
                </Button>
              )}
              {loadingFile != '' && loadingFile == pdfReport && (
                <Spinner animation="border" size="sm" className="d-flex" />
              )}
              {(!loadingFile || loadingFile != xlsReport) && (
                <Button
                  className={`${xlsReport ? 'payment-statement__report--done' : ''}`}
                  title="Baixar relatório em XLS"
                  variant="link"
                  disabled={!xlsReport}
                  onClick={() => processDownload(token, `/api/v1/payment/file/${xlsReport}`, xlsReport, setLoadingFile)}
                >
                  <img src={IconXLS} alt="ícone de representação de um arquivo XLS" />
                </Button>
              )}
              {loadingFile != '' && loadingFile == xlsReport && (
                <Spinner animation="border" size="sm" className="d-flex" />
              )}
              {(!loadingFile || loadingFile != xmlReport) && (
                <Button
                  className={''}
                  title="Baixar relatório em XML"
                  variant="link"
                  disabled={true}
                  onClick={() => processDownload(token, `/api/v1/payment/file/${xmlReport}`, xmlReport, setLoadingFile)}
                >
                  <img src={IconXML} alt="ícone de representação de um arquivo XML" />
                </Button>
              )}
              {loadingFile != '' && loadingFile == xmlReport && (
                <Spinner animation="border" size="sm" className="d-flex" />
              )}
              {(!loadingFile || loadingFile != xmlReportExchange) && (
                <Button
                  className={''}
                  title="Baixar relatório em XML Intercâmbio"
                  variant="link"
                  disabled={true}
                  onClick={() =>
                    processDownload(
                      token,
                      `/api/v1/payment/file/${xmlReportExchange}`,
                      xmlReportExchange,
                      setLoadingFile
                    )
                  }
                >
                  <img src={IconXMLExchange} alt="ícone de representação de um arquivo XML" />
                </Button>
              )}
              {loadingFile != '' && loadingFile == xmlReportExchange && (
                <Spinner animation="border" size="sm" className="d-flex" />
              )}
            </div>
          </Td>
          <Td>
            {!loadingFile && (
              <Button
                className={`${pdfReport ? 'payment-statement__report--done' : ''}`}
                title="Remover item da lista"
                variant="link"
                disabled={!pdfReport}
                onClick={() => removeDoc(index)}
              >
                <img src={TrashCanIcon} alt="ícone de representação de uma lixeira" width={20} height={20} />
              </Button>
            )}
          </Td>
        </Tr>
      )
    })
  }

  useEffect(() => {
    if (errorPaymentDemonstrativeCopan) {
      setErrorMessage(errorPaymentDemonstrativeCopan)
      handleShow()
      setGeneratingNewDoc(false)
    }
  }, [errorPaymentDemonstrativeCopan])

  useEffect(() => {
    const { host = '', search = '' } = window?.location || {}
    const isDebugModeTemp = isDebugMode({ host, search })
    setDebugMode(isDebugModeTemp)

    const reportsBeingGeneratedCopan = JSON.parse(localStorage.getItem('reportsBeingGeneratedCopan')) || []

    const date = new Date().toISOString().split('T')[0]
    let reports = []
    let i = 0
    reportsBeingGeneratedCopan.forEach((rep) => {
      if (rep.created_at == date) {
        reports.push(rep)
      } else {
        dispatch(paymentStatementCopanActions.removeDocCopan(i))
      }
      i += 1
    })
    localStorage.setItem('reportsBeingGeneratedCopan', JSON.stringify(reports))

    setReportsInProgress(reports || [])
  }, [])

  useEffect(() => {
    function checkStatusEvery5Seconds() {
      const reportsBeingGeneratedCopan = JSON.parse(localStorage.getItem('reportsBeingGeneratedCopan')) || []
      const date = new Date().toISOString().split('T')[0]
      let reports = []
      reportsBeingGeneratedCopan.forEach((rep) => {
        if (rep.created_at == date) {
          reports.push(rep)
        }
      })

      setReportsInProgress(reports || [])

      if (generatingNewDoc && reports.length) {
        setGeneratingNewDoc(false)
      }

      Array.isArray(reports) &&
        reports
          .filter((item) => !item.applications.paymentDemonstrative.reportsPerDay.success)
          .forEach((item) => {
            dispatch(paymentStatementCopanActions.generateDocsCopan({ ...item, store, debugMode }))
          })
    }

    if (intervalId) {
      clearInterval(intervalId)
    }

    setIntervalId(setInterval(checkStatusEvery5Seconds, 5000))

    return function cleanup() {
      clearInterval(intervalId)
    }
  }, [reportsData])

  const handleDateChangeBlur = (e) => {
    setCustomInput('')
    if (e.target.value) {
      validateSelectedDay(e.target.value)
    }
  }

  const validateSelectedDay = (dateStr) => {
    let dateParts = dateStr.split('/')
    const date = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0])
    const result = DateTime.fromJSDate(date).toFormat('dd/MM/yyyy')
    if (dateStr != result) {
      setErrorMessage('Data inválida.')
      handleShow()
      setStartDate(new Date())
    } else {
      const currentDate = new Date()
      let d1 = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
      let d2 = DateTime.fromJSDate(currentDate).toFormat('yyyy-MM-dd')
      if (d1 > d2) {
        setErrorMessage('Data inválida, não é possível consultar uma data futura.')
        handleShow()
        setStartDate(new Date())
      }
    }
  }

  const handleFocus = () => {
    const maskedInput = <MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" size="20" />
    setCustomInput(maskedInput)
  }

  return (
    <>
      <Container className="mt-5 mb-5">
        <Row>
          <Col>
            <Typography variant="h2" color="primary" cssClass="title-semibold-md payment-statement__title mb-3">
              {data.title}
            </Typography>

            <div className="bg-green-dark-100">
              <Typography variant="p" color="white" cssClass="p-2 uppercased">
                {login_user?.name}
              </Typography>
              <Typography variant="p" color="white" cssClass="p-2 uppercased payment-statement__code">
                Código Unimed: {login_user?.contract}
              </Typography>
            </div>

            <Typography id="date" cssClass="mb-3 mt-4" variant="p" color="gray-100">
              Informe uma data para a consulta e clique em Gerar para o formato desejado:
            </Typography>

            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              maxDate={new Date()}
              onBlur={(e) => handleDateChangeBlur(e)}
              onClickOutside={(e) => handleDateChangeBlur(e)}
              onFocus={() => handleFocus()}
              customInput={customInput}
              title="Data"
              ariaLabelledBy="date"
            />

            <Button
              className="mt-4 mb-5"
              variant="outline-primary"
              size="lg"
              onClick={() => generateDocs(startDate)}
              disabled={generatingNewDoc}
            >
              Gerar documentos{' '}
              {generatingNewDoc && <Spinner className="ml-2" animation="border" role="status" size="sm" />}
            </Button>

            <CustomModal
              open={showError}
              closeModal={() => handleClose()}
              size="sm"
              title="Demonstrativo de Pagamentos"
              footer={{
                closeButton: true,
              }}
            >
              <p className="p-3">
                <strong>{errorMessage}</strong>
              </p>
            </CustomModal>
          </Col>
        </Row>

        {reportsInProgress.length > 0 && (
          <Row>
            <Col>
              <Table className="responsive-table payment-statement__process">
                <Thead>
                  <Tr>
                    <Th>Status</Th>
                    <Th>Data</Th>
                    <Th className="text-center">Documentos</Th>
                    <Th></Th>
                  </Tr>
                </Thead>

                <Tbody>{renderTableItems(reportsInProgress)}</Tbody>
              </Table>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}

export default DemonstrativoPagamentoCopan
